const getters = {
  userinfo: state => state.user.userinfo,
  token: state => state.user.token,
}
export default getters
